import reservationsService from "api/reservationsService"
import { AxiosResponse } from "axios"
import { useQuery } from "react-query"

const useGetCarWashBoxes = (carWashId: number, enabled: boolean) => {
  return useQuery(
    ["reservation-get-car-wash-boxes", carWashId],
    async () => {
      try {
        const res: AxiosResponse<any> =
          await reservationsService.getCarWashBoxes(carWashId)
        return res.data
      } catch (err: any) {
        err.response
      }
    },
    { enabled },
  )
}

export default useGetCarWashBoxes